import React, { useRef } from "react"
import { Sphere } from "@react-three/drei"
import PropTypes from "prop-types"
import * as THREE from "three"
import { useFrame } from "@react-three/fiber"

const Heat = (props) => {
  const ref = useRef()

  useFrame((state) => {
    const t = state.clock.getElapsedTime()
    ref.current.rotation.z = Math.sin(t) * props.valueSolarExposure * 10
    ref.current.rotation.y = Math.sin(t) * props.valueSolarExposure * Math.PI * 5
    ref.current.position.z = Math.sin(t) * props.valueSolarExposure * 2
  })

  const heartMaterial = new THREE.MeshPhysicalMaterial({
    color: new THREE.Color(
      `hsl(${THREE.MathUtils.mapLinear(
        props.valueMaxTemp,
        0,
        1,
        250,
        350
      )}, 100%, 75%)`
    ).convertSRGBToLinear(),
    roughness: 0,
    clearcoat: 1,
    clearcoatRoughness: 0,
  })

  const outerMaterial = new THREE.MeshPhysicalMaterial({
    color: new THREE.Color(
      `hsl(${THREE.MathUtils.mapLinear(
        props.valueMaxTemp,
        0,
        1,
        130,
        230
      )}, 100%, 75%)`
    ).convertSRGBToLinear(),
    roughness: 0,
    clearcoat: 1,
    clearcoatRoughness: 0,
  })

  const spheres = [...Array(7)].map((_, index) => {
    const angle = (Math.PI * 2 * index) / 7
    const radius = 1 // Slightly smaller radius for better visibility
    const x = radius * Math.sin(angle)
    const y = -radius * Math.cos(angle)

    return (
      <Sphere
        key={index}
        args={[0.5, 64, 64]}
        position={[x, y, 0]}
        material={outerMaterial}
      />
    )
  })

  return (
    <group
      scale={props.valueSolarExposure / 4 + 0.25}
      position={[props.xPos, 0, 0]}
    >
      <group ref={ref}>
        <group>
          <Sphere
            scale={0.8}
            args={[1, 64, 64]}
            position={[0, 0, 0]}
            material={heartMaterial}
          />
          {spheres}
        </group>
      </group>
    </group>
  )
}

Heat.propTypes = {
  xPos: PropTypes.number,
  valueMaxTemp: PropTypes.number,
  valueSolarExposure: PropTypes.number,
}

export default Heat
